import React from 'react';
import {MasterLayout} from 'components/layouts';
import {RequestDetail} from 'components/requests';
import MemberZone from './MemberZone.jsx';
import {UserLayout} from 'components/layouts/user';
import title from 'constants/TitlePages.js';

class RequestDetailContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.RequestDetailContainer;
  }

  render() {
    return (
      <MasterLayout>
        <UserLayout active="my-requests">
          <RequestDetail id={this.props.match.params.id} type='MY_REQUESTS'/>
        </UserLayout>
      </MasterLayout>
    );
  }
}

export default MemberZone(RequestDetailContainer);



// WEBPACK FOOTER //
// ./pages/users/RequestDetail.jsx